import { lighten } from 'polished';

import { Theme } from '@silvertours/front-shared';

const theme: Theme.Theme = {
  color: {
    // brand colours
    primary: '#00977d', // green
    primary70: lighten(0.04, '#00977d'),
    primary100: '#006e5b',
    primaryHighlight: '#cceae5',
    secondary100: '#222', // dark gray,
    secondaryHighlight: '#79b7ac',
    primaryGradient1: '#6ec2b7',

    // natural colours
    natural100: '#000',
    natural70: '#ff4b19',
    natural50: '#cecece',
    natural40: '#666666',
    natural30: '#747474',
    natural20: '#eee',
    natural10: '#f8f8f8',
    natural0: '#fff',

    // notification colours
    info: '#3694ba',
    warning: '#ffa800',
    error: '#d63f24',
    success: '#75b21b',
  },

  gradient: {
    green: { from: '#0D8C76', to: '#06705F' },
    orange: { from: '#FF4B19', to: '#FF8664' },
    mint: { from: '#6EC2B7', to: '#4FBBAD' },
    brand: { from: '#FF4B19', via: '#E4A5A3', to: '#6CC2B6' },
  },

  fontFamily: {
    default: "'Source Sans Pro', ui-sans-serif, system-ui, sans-serif",
    alternate:
      "Quicksand, Bryant, 'Proxima Nova Soft', Arial Rounded MT Bold, sans-serif",
  },
  fontWeight: {
    body: 'normal',
    heading: 'bold',
  },
  fontSize: {
    xl: {
      size: '1.875rem',
      lineHeight: '1.2',
    },
    lg: {
      size: '1.375rem',
      lineHeight: '1.2',
    },
    md: {
      size: '1.125rem',
      lineHeight: '1.2',
    },
    sm: {
      size: '1rem',
      lineHeight: '1.5',
    },
    xs: {
      size: '0.875rem',
      lineHeight: '1.2',
    },
    xxs: {
      size: '0.625rem',
      lineHeight: '1.2',
    },
  },
  baseSize: '11px',
  spacing: {
    0: '0',
    5: '0.125rem',
    10: '0.25rem',
    20: '0.5rem',
    30: '0.75rem',
    40: '1rem',
    50: '1.5rem',
    60: '2rem',
    70: '2.5rem',
    80: '3rem',
    90: '4rem',
    100: '4.5rem',
    110: '6rem',
    120: '7rem',
    130: '8rem',
    140: '9rem',
    150: '10rem',
  },
  borderRadius: {
    none: '0',
    xxs: '0.125rem',
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1.5rem',
  },
  boxShadow: {
    sm: '0 0.375rem 1.25rem rgb(0 0 0 / 6%)',
    md: '0 0.625rem 1.5rem rgb(0 0 0 / 8%)',
    lg: '0 0.625rem 2rem rgb(0 0 0 / 14%)',
  },
  backgroundImage: {
    // @see https://www.scien.cx/2021/11/10/adding-radial-gradients-to-tailwind-css/
    none: 'none',
  },
  mq: Theme.mq,
};

export { theme };
